
/*

Suresh        09/23/2022 2701306337 UI Alignments in Side nav, Record Format Fixed
RajeshK       09/26/2022 2701306337 report master changes
RajeshK       09/26/2022 2701306337 fixed conflicts
Saikrishna    10/06/2022 2701306337 Removed unecesarry console.log statements
Saikrishna    10/12/2022 2701306337 Print_Payload_changes
saikrishna 11/03/2022 2701306337 changed the paginationOptions

*/
import React, {createRef, useEffect, useState, useContext} from 'react';
// import MaterialTable from "material-table";
import {
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TablePagination,
  TextField,
  Button,
} from '@material-ui/core';
import {ThemeContext} from '../../../../../themes/ThemeProvider';

import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows, tablePageRows} from '../../../../../constants/ReusableTablePagination';
import GuiTable from '../../../../../components/FormComponents/GuiTable';

export default function RecordFormatFieldSearchTable({
  searchData,
  setSelectedRows,
  selectedRows,
  fieldType,
  globalFieldCode,
  globalFieldName,
  submit,
  setSubmit,
  fieldListId,
  setFieldListId,
  selectionChange,
  setSelectionChange,
  selectionState,
  setSelectionState,
  setFieldListCode,
  fieldListCode,
  deletedRules,
  setDeletedRules,
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const columns = [
    {
      title: 'Category',
      field: 'category',
    },
    {
      title: 'Global Field Code',
      field: 'globalField',
    },
    {
      title: 'Global Field Name',
      field: 'displayName',
      type: 'string',
      render: (rowData) => <span>{rowData?.tableField}</span>,
    },
    {
      title: 'Description',
      field: 'description',
    },
  ];
  const columns3 = [
    {
      title: 'Display Name',
      field: 'displayName',
    },
    {
      title: 'BRE Formula Group Code',
      field: 'code',
    },
    {
      title: 'Description',
      field: 'description',
    },
  ];
  const columns2 = [
    {
      title: 'Value',
      field: 'value',
    },
  ];
  const fieldListColumns = [
    {
      title: 'Category',
      field: 'category',
    },
    {
      title: 'Group Code',
      field: 'groupCode',
    },
    {
      title: 'Field Code',
      field: 'globalField',
    },
    {
      title: 'Field Description',
      field: 'description',
    },
    {
      title: 'Table Name',
      field: 'tableName',
    },
  ];
  const tableRef = createRef();
  const tableRef1 = createRef();
  const tableRef2 = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const {fieldListData} = useSelector(({addFieldList}) => addFieldList);
  const {recordFormatData} = useSelector(({addRecordFormat}) => addRecordFormat);

  const [fieldListApiData, setFieldListApiData] = useState([]);

  const {letterConstantData} = useSelector(({letterSummary}) => letterSummary);
  useEffect(() => {
    if (tableRef?.current && submit) {
      tableRef.current.onQueryChange();
    }
  }, [submit, fieldType, globalFieldCode, globalFieldName]);
  useEffect(() => {
    if (tableRef1?.current && submit) {
      tableRef1.current.onQueryChange();
    }
  }, [submit, fieldType]);
  useEffect(() => {
    if (tableRef2?.current) {
      tableRef2.current.onQueryChange();
    }
  }, [letterConstantData]);
  const [letterConstData, setLetterConstData] = useState([]);
  useEffect(() => {
    const editable = letterConstantData.map((o) => ({...o}));
    if (editable?.length > 0) {
      const newObj = {};
      selectedRows.forEach((el) => {
        if (!newObj[el?.value]) {
          newObj[el?.value] = el;
        }
      });

      const newRow = editable.map((elem) => {
        if (newObj[elem?.value]) {
          return {...elem, tableData: {...elem.tableData, checked: true}};
        } else {
          return {...elem, tableData: {...elem.tableData, checked: false}};
        }
      });
      setLetterConstData(newRow);
    }
  }, [letterConstantData]);

  useEffect(() => {
    const editable =
      fieldListData?.globalFieldsList?.length > 0 ?
        fieldListData?.globalFieldsList?.map((o) => ({...o})) :
        [];

    if (editable?.length > 0) {
      const newObj = {};
      selectedRows.forEach((el) => {
        if (!newObj[el?.globalField]) {
          newObj[el?.globalField] = el;
        }
      });
      const newRow = editable?.map((elem) => {
        if (newObj[elem?.globalField]) {
          return {...elem, tableData: {...elem.tableData, checked: recordFormatData?.fieldList === fieldListCode}};
        } else {
          return {...elem, tableData: {...elem.tableData, checked: false}};
        }
      });
      fieldListData?.globalFieldsList?.length > 0 ?
        setFieldListApiData(newRow) :
        setFieldListApiData([]);
    }
    fieldListData?.globalFieldsList?.length <= 0 && setFieldListApiData([]);
  }, [fieldListData]);

  useEffect(() => {
    let initial = false;
    if (
      fieldListCode &&
      fieldListCode !== fieldListId &&
      selectedRows?.length > 0 &&
      selectionChange
    ) {
      for (const i in selectedRows) {
        if (selectedRows[i]?.fieldListCode !== fieldListId && i !== selectedRows?.length - 1) {
          initial = true;
          break;
        }
      }
    }
    if (
      fieldListCode &&
      fieldListCode !== fieldListId &&
      initial &&
      selectionChange &&
      selectedRows?.length > 1
    ) {
      const newGlobalFields = selectedRows?.filter((item, index) => {
        if (item?.fieldType !== 'Global Field' || index === selectedRows?.length - 1) {
          return item;
        }
      });
      setSelectionState(false);
      setSelectedRows([...newGlobalFields]);
    }
  }, [fieldListCode, selectionChange]);
  useEffect(() => {
    if (selectionChange) {
      setFieldListId(fieldListCode);
    }
  }, [selectionChange]);


  return (
    <>
      <Grid item xs={12}>
        {fieldListCode && (
          <div className="col d-flex align-items-center justify-content-between px-1 py-2 ">
            <div>
              <p className={`${classes.searchText} mt-2`}>Field List Code : {fieldListCode}</p>
            </div>
            <div>
              <Button
                variant="contained"
                onClick={() => {
                  setFieldListCode(null);
                  setSelectionChange(false);
                }}
                className={`themeing-buttons ${classes.buttonRoot}`}
              >
                Back
              </Button>
            </div>
          </div>
        )}

        <div className="custom-table">
          {fieldType === 'Global Field' && (
            <GuiTable
              title=""
              columns={fieldType === 'Global Field' ? columns : []}
              icons={tableIcons}
              tableRef={tableRef}
              data={(query) =>
                new Promise((resolve) => {
                  const url = fieldType === 'Global Field' ? `globalfield/search/all` : '';
                  const bodyObj =
                    fieldType === 'Global Field' ?
                      {
                        globalField: globalFieldCode || '',
                        category: searchData?.category ? searchData.category[0] : '',
                        displayName: globalFieldName || '',
                        tableName: searchData?.tableName ? searchData.tableName : '',
                        tableField: searchData?.tableField ? searchData.tableField : '',
                        limit: query.pageSize ? query.pageSize : null,
                        description: searchData?.description ? searchData?.description : '',
                        page:
                            submit ?
                              1 :
                              arrayLast && query.page >= 1 ?
                                query.page :
                                arrayLast ?
                                  (query.page <= 1 && query.page + 1) || query.page - 1 :
                                  query.page + 1,
                        orderDirection: query.orderDirection,
                        orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                      } :
                      {};
                  if (!fieldType) {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 0,
                    });
                  } else {
                    httpPaginationPost(url, bodyObj)
                      .then((response) => {
                        if (response?.status === 200) {
                          const newObj = {};
                          selectedRows?.forEach((el) => {
                            if (!newObj[el.globalField]) {
                              newObj[el.globalField] = el;
                            }
                          });
                          const newRow = response.data.response.resultObject.map((elem) => {
                            if (newObj[elem.globalField]) {
                              return {...elem, tableData: {...elem.tableData, checked: true}};
                            } else {
                              return {
                                ...elem,
                                tableData: {...elem.tableData, checked: false},
                              };
                            }
                          });
                          resolve({
                            data: newRow.length > 0 ? newRow : [],
                            page: response.data.response.page - 1,
                            totalCount: response.data.response.count,
                          });
                          setSubmit(false);
                          setArrayLast(response.data.response.resultObject.length === 1);
                        } else {
                          resolve({
                            data: [],
                            page: 0,
                            totalCount: 5,
                          });
                          dispatch({
                            type: 'FETCH_ERROR',
                            payload: response && response.message ? response.message : null,
                          });
                        }
                      })
                      .catch((response) => {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      });
                  }
                })
              }
              options={{
                toolbar: false,
                search: false,
                selection: true,
                pageSize: rows,
                showSelectAllCheckbox: false,
                emptyRowsWhenPaging: false,
                headerStyle: {
                  fontWeight: 'bold',
                },
              }}
              components={{
                Pagination: (props) => (
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                ),
              }}
              onSelectionChange={(rows, unSelected) => {
                if (unSelected?.tableData?.checked) {
                  setSelectedRows([
                    ...selectedRows,
                    {
                      ...unSelected,
                      fieldCode: unSelected.globalField,
                      ...getFields({...unSelected, fieldCode: unSelected.globalField}),
                      tableData: {...unSelected.tableData, id: unSelected.globalField},
                      fieldType: 'Global Field',
                      dataType: unSelected?.dataType,
                    },
                  ]);
                } else {
                  const updatedRows = [...selectedRows]
                    .filter((ele) => {
                      return ele.globalField !== unSelected.globalField;
                    })
                    .map((ele) => {
                      return {...ele, tableData: {...ele.tableData, id: ele.globalField}};
                    });
                  setSelectedRows(updatedRows);
                }
              }}
            />
          )}
          {fieldType === 'BRE Group' && (
            <GuiTable
              title=""
              columns={fieldType === 'BRE Group' ? columns3 : []}
              icons={tableIcons}
              tableRef={tableRef}
              data={(query) =>
                new Promise((resolve) => {
                  const url = fieldType === 'BRE Group' ? `rules/search/all` : '';
                  const bodyObj =
                    fieldType === 'BRE Group' ?
                      {
                        code: searchData?.code ? searchData.code : '',
                        description: searchData?.description ? searchData.description : '',
                        displayName: searchData?.displayName ? searchData?.displayName : '',
                        limit: query.pageSize ? query.pageSize : null,
                        returnType: searchData?.returnType ? searchData?.returnType : '',
                        ruleType: 'FormulaRuleGroup',
                        page:
                            arrayLast && query.page >= 1 ?
                              query.page :
                              arrayLast ?
                                (query.page <= 1 && query.page + 1) || query.page - 1 :
                                query.page + 1,
                        orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                        orderDirection: query?.orderDirection ? query?.orderDirection : '',
                      } :
                      {};
                  if (!fieldType) {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 0,
                    });
                  } else {
                    httpPaginationPost(url, bodyObj)
                      .then((response) => {
                        if (response?.status === 200) {
                          const newObj = {};
                          selectedRows.forEach((el) => {
                            if (!newObj[el.code]) {
                              newObj[el.code] = el;
                            }
                          });
                          const newRow = response.data.response.resultObject.map((elem) => {
                            if (newObj[elem.code]) {
                              return {...elem, tableData: {...elem.tableData, checked: true}};
                            } else {
                              return {
                                ...elem,
                                tableData: {...elem.tableData, checked: false},
                              };
                            }
                          });
                          resolve({
                            data: newRow.length > 0 ? newRow : [],
                            page: response.data.response.page - 1,
                            totalCount: response.data.response.count,
                          });
                          setArrayLast(response.data.response.resultObject.length === 1);
                        } else {
                          resolve({
                            data: [],
                            page: 0,
                            totalCount: 5,
                          });
                          dispatch({
                            type: 'FETCH_ERROR',
                            payload: response && response.message ? response.message : null,
                          });
                        }
                      })
                      .catch((response) => {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      });
                  }
                })
              }
              options={{
                toolbar: false,
                search: false,
                selection: true,
                pageSize: rows,
                showSelectAllCheckbox: false,
                emptyRowsWhenPaging: false,
                headerStyle: {
                  fontWeight: 'bold',
                },
              }}
              components={{
                Pagination: (props) => (
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                ),
              }}
              onSelectionChange={(rows, unSelected) => {
                if (unSelected?.tableData?.checked) {
                  setSelectedRows([
                    ...selectedRows,
                    {
                      ...unSelected,
                      fieldCode: unSelected.code,
                      ...getFields({...unSelected, fieldCode: unSelected.code}),
                      tableData: {...unSelected.tableData, id: unSelected.code},
                      fieldType: 'BRE Group',
                    },
                  ]);
                } else {
                  const updatedRows = [...selectedRows]
                    .filter((ele) => ele.code !== unSelected.code)
                    .map((ele) => {
                      return {...ele, tableData: {...ele.tableData, id: ele.code}};
                    });
                  setSelectedRows(updatedRows);
                }
              }}
            />
          )}
          {fieldType === 'Constants' && (
            <GuiTable
              title=""
              columns={columns2}
              icons={tableIcons}
              data={letterConstData}
              options={{
                toolbar: false,
                search: false,
                selection: true,
                pageSize: rows,
                showSelectAllCheckbox: false,
                pageSizeOptions: tablePageRows,
                emptyRowsWhenPaging: false,
                headerStyle: {
                  fontWeight: 'bold',
                },
              }}
              onSelectionChange={(rows, unSelected) => {
                if (unSelected?.tableData?.checked) {
                  setSelectedRows([
                    ...selectedRows,
                    {
                      ...unSelected,
                      fieldCode: unSelected.value,
                      ...getFields({...unSelected, fieldCode: unSelected.value}),
                      tableData: {...unSelected.tableData, id: unSelected.value},
                      fieldType: 'Constant',
                    },
                  ]);
                } else {
                  const updatedRows = [...selectedRows]
                    .filter((ele) => ele.value !== unSelected.value)
                    .map((ele) => {
                      return {...ele, tableData: {...ele.tableData, id: ele.value}};
                    });
                  setSelectedRows(updatedRows);
                }
              }}
            />
          )}
          {fieldType === 'Field List' && fieldListCode && (
            <>
              <GuiTable
                title=""
                columns={fieldListColumns}
                icons={tableIcons}
                data={fieldListApiData}
                options={{
                  toolbar: false,
                  search: false,
                  selection: true,
                  pageSize: rows,
                  showSelectAllCheckbox: false,
                  pageSizeOptions: tablePageRows,
                  emptyRowsWhenPaging: false,
                  headerStyle: {
                    fontWeight: 'bold',
                  },
                }}
                onSelectionChange={(rows, unSelected) => {
                  selectionState && setSelectionChange(true);
                  if (unSelected?.tableData?.checked) {
                    setSelectedRows([
                      ...selectedRows,
                      {
                        ...unSelected,
                        fieldCode: unSelected.globalField,
                        ...getFields({...unSelected, fieldCode: unSelected.globalField}),
                        tableData: {...unSelected.tableData, id: unSelected.globalField},
                        fieldType: 'Global Field',
                        dataType: unSelected?.dataType,
                        fieldListCode: fieldListCode,
                      },
                    ]);
                  } else {
                    const updatedRows = [...selectedRows]
                      .filter((ele) => {
                        return ele.globalField !== unSelected.globalField;
                      })
                      .map((ele) => {
                        return {...ele, tableData: {...ele.tableData, id: ele.globalField}};
                      });
                    setSelectedRows(updatedRows);
                  }
                }}
              />
            </>
          )}
        </div>
      </Grid>
    </>
  );
}

export const getFields = (unSelected) => {
  return {
    seqNo: (
      values = {},
      handleChange,
      touched = {},
      errors = {},
      inputFieldValues,
      setInputFieldValues,
      setFieldValue,
    ) => {
      return (
        <>
          <div key={unSelected.fieldCode} className="format-field">
            <TextField
              margin="dense"
              type="number"
              variant="outlined"
              placeholder={`Enter seq number`}
              InputLabelProps={{
                shrink: true,
              }}
              name={'seqNo' + unSelected.fieldCode}
              value={values['seqNo' + unSelected.fieldCode]}
              onChange={(e) => {
                setFieldValue('seqNo' + unSelected.fieldCode, e.target.value);
                inputFieldValues['seqNo' + unSelected.fieldCode] = e.target.value;
              }}
              error={
                touched['seqNo' + unSelected.fieldCode] && errors['seqNo' + unSelected.fieldCode]
              }
            />
            <FormHelperText style={{color: 'red', position: 'sticky', padding: '2px '}}>
              {touched['seqNo' + unSelected.fieldCode] && errors['seqNo' + unSelected.fieldCode]}
            </FormHelperText>
          </div>
        </>
      );
    },
    fieldLength: (
      values = {},
      handleChange,
      touched = {},
      errors = {},
      inputFieldValues,
      setInputFieldValues,
      setFieldValue,
    ) => {
      const fieldLengthClassName = touched['fieldLength' + unSelected.fieldCode] &&
      errors['fieldLength' + unSelected.fieldCode] ? 'form-group' : null;
      return (
        <>
          <div key={unSelected.fieldCode} className={`format-field-length ${fieldLengthClassName}`}>
            <TextField
              margin="dense"
              type="text"
              variant="outlined"
              className="w-100"
              placeholder={`Enter field length`}
              InputLabelProps={{
                shrink: true,
              }}
              name={'fieldLength' + unSelected.fieldCode}
              value={values['fieldLength' + unSelected.fieldCode]}
              onChange={(e) => {
                setFieldValue('fieldLength' + unSelected.fieldCode, e.target.value);
                inputFieldValues['fieldLength' + unSelected.fieldCode] = e.target.value;
              }}
              error={
                touched['fieldLength' + unSelected.fieldCode] &&
                errors['fieldLength' + unSelected.fieldCode]
              }
            />
            {!values['fieldLength' + unSelected.fieldCode] && (
              <FormHelperText style={{color: 'red'}} variant="outlined">
                {touched['fieldLength' + unSelected.fieldCode] &&
                  errors['fieldLength' + unSelected.fieldCode] &&
                  errors['fieldLength' + unSelected.fieldCode]}
              </FormHelperText>
            )}
          </div>
        </>
      );
    },
    format: (
      values = {},
      handleChange,
      touched = {},
      errors = {},
      inputFieldValues,
      setinputFieldValues,
      setFieldValue,
      dataType,
      dropDownData,
    ) => {
      return (
        <>
          <div key={unSelected.fieldCode} className="format-field">
            <FormControl margin="dense" variant="outlined" fullWidth className="mw-120">
              <Select
                fullWidth
                name={'format' + unSelected.fieldCode}
                className="select-gender"
                disabled={dataType !== 'Date'}
                value={values['format' + unSelected.fieldCode] || 'none'}
                onChange={(e) => {
                  setFieldValue('format' + unSelected.fieldCode, e.target.value);
                  inputFieldValues['format' + unSelected.fieldCode] = e.target.value;
                }}
              >
                <MenuItem value="none" key="none" disabled>
                  <span className="defaultSelected">Select Any</span>
                </MenuItem>
                {dropDownData?.DATE_FORMAT &&
                  dropDownData?.DATE_FORMAT.map((sep) => (
                    <MenuItem value={sep.value} key={sep.key}>
                      {sep.value}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <FormHelperText style={{color: 'red', position: 'sticky', padding: '2px '}}>
              {touched['format' + unSelected.fieldCode] &&
                errors['format' + unSelected.fieldCode] &&
                errors['format' + unSelected.fieldCode]}
            </FormHelperText>
          </div>
        </>
      );
    },
    printTotals: (
      values = {},
      handleChange,
      touched = {},
      errors = {},
      inputFieldValues,
      setInputFieldValues,
      setFieldValue,
    ) => {
      return (
        <>
          <div key={unSelected.fieldCode} className="format-field">
            <FormControl margin="dense" variant="outlined" fullWidth>
              <Select
                name={'printTotals' + unSelected.fieldCode}
                className="select-gender"
                value={values['printTotals' + unSelected.fieldCode] || 'none'}
                onChange={(e) => {
                  setFieldValue('printTotals' + unSelected.fieldCode, e.target.value);
                  inputFieldValues['printTotals' + unSelected.fieldCode] = e.target.value;
                }}
              >
                <MenuItem value="none" key="none" disabled>
                  <span className="defaultSelected"> Select Any</span>
                </MenuItem>
                <MenuItem value={'yes'} key={'Y'}>
                  Yes
                </MenuItem>
                <MenuItem value={'no'} key={'N'}>
                  No
                </MenuItem>
              </Select>
            </FormControl>
            <FormHelperText style={{color: 'red', position: 'sticky', padding: '2px '}}>
              {touched['printTotals' + unSelected.fieldCode] &&
                errors['printTotals' + unSelected.fieldCode] &&
                errors['printTotals' + unSelected.fieldCode]}
            </FormHelperText>
          </div>
        </>
      );
    },
    fieldHeader: (
      values = {},
      handleChange,
      touched = {},
      errors = {},
      inputFieldValues,
      setinputFieldValues,
      setFieldValue,
    ) => {
      return (
        <>
          <div key={unSelected.fieldCode} className="format-field">
            <TextField
              margin="dense"
              type="text"
              variant="outlined"
              placeholder={`Enter Field Header`}
              InputLabelProps={{
                shrink: true,
              }}
              name={'fieldHeader' + unSelected.fieldCode}
              value={values['fieldHeader' + unSelected.fieldCode]}
              onChange={(e) => {
                setFieldValue('fieldHeader' + unSelected.fieldCode, e.target.value);
                inputFieldValues['fieldHeader' + unSelected.fieldCode] = e.target.value;
              }}
              error={
                touched['fieldHeader' + unSelected.fieldCode] &&
                errors['fieldHeader' + unSelected.fieldCode]
              }
            />
            <FormHelperText style={{color: 'red'}}>
              {touched['fieldHeader' + unSelected.fieldCode] &&
                errors['fieldHeader' + unSelected.fieldCode] &&
                errors['fieldHeader' + unSelected.fieldCode]}
            </FormHelperText>
          </div>
        </>
      );
    },
  };
};
